export type ActorType = "user" | "admin" | "lawyer" | "system";

export type ActionType =
  | "uploaded_document"
  | "updated_document"
  | "deleted_document"
  | "added_estate_item"
  | "updated_estate_item"
  | "approved_estate_item"
  | "declined_estate_item"
  | "deleted_estate_item"
  | "added_contact"
  | "updated_contact"
  | "deleted_contact"
  | "invited_contact"
  | "accepted_invitation"
  | "connected_plaid_account"
  | "disconnected_plaid_account"
  | "signed_tpa"
  | "revoked_tpa"
  | "reactivated_tpa"
  | "booked_meeting"
  | "submitted_task"
  | "submitted_elayne_task"
  | "completed_task"
  | "completed_module"
  | "updated_user_profile"
  | "updated_deceased_profile"
  | "updated_relationship"
  | "requested_account_deletion"
  | "tier_purchased"
  | "tier_upgraded"
  | "address_link_repointed"
  | "address_corrected"
  | "address_merged"
  | "address_validated"
  | "property_updated"
  | "sent_estate_account_reminder";

export interface ActivityLogEntry {
  id: number;
  created_at: string;
  estate_id: number;
  action_type: ActionType;
  actor_type: ActorType;
  user_id: number | null;
  admin_id: string | null;
  entity_type: string | null;
  entity_id: string | null;
  metadata: Record<string, unknown>;
  actor_name: string | null;
  actor_email: string | null;
}

// An activity entry is "unread" for a lawyer when it was not performed by a
// lawyer and is newer than the last time the lawyer opened that estate's log.
export function isUnreadForLawyer(
  entry: Pick<ActivityLogEntry, "actor_type" | "created_at">,
  seenAt: string | null,
): boolean {
  if (entry.actor_type === "lawyer") return false;
  if (!seenAt) return true;
  return entry.created_at > seenAt;
}
